/**
 * Generated runtime TestId mirror for frontend/src/components/restriction-rules/WorkflowTimelineCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const WorkflowTimelineCardTestIds = {
  cardTitleWorkflowTimeline: "card-title-workflow-timeline",
  workflowTimelineApproved: "workflow-timeline-approved",
  workflowTimelineCancelled: "workflow-timeline-cancelled",
  workflowTimelineCard: "workflow-timeline-card",
  workflowTimelineCreated: "workflow-timeline-created",
  workflowTimelineRejected: "workflow-timeline-rejected",
  workflowTimelineSubmitted: "workflow-timeline-submitted"
} as const;
